<template>
  <nav class="navbar" :class="[
            {'navbar-expand-md': expand},
            {'navbar-transparent': transparent},
            {[`bg-${type}`]: type}
         ]">
    <div :class="containerClasses">
      <div class="local__page  align-items-center m-md-0">
        <div>
            <!-- {{this.$route.meta.title}} -->
            <img src="/img/icons/icone_navbar/parcours_soins.png" class="img-fluid mr-3" alt="Parcours de soins" v-if="this.$route.meta.title == $t('message.Trajet')" width="30">
            <img src="/img/icons/icone_navbar/gestion_user.png" class="img-fluid mr-3" alt="Gestion des Utilisateurs" v-if="this.$route.meta.title == $t('message.userManagement') || this.$route.meta.title == $tc('message.managers', 2) || this.$route.meta.title == $tc('message.subscribers', 2) || this.$route.meta.title == $tc('message.patients', 2) || this.$route.meta.title == $tc('message.controlDoctors', 2) || this.$route.meta.title == $tc('message.partners', 2) || this.$route.meta.title == $tc('message.associations') || this.$route.meta.title == $t('message.addSubscriber') || this.$route.meta.title == $t('message.addPatient') ||  this.$route.meta.title == $t('message.addControlDoctors') || this.$route.meta.title == $t('message.addPartners') || this.$route.meta.title == $t('message.addAssociation') || this.$route.meta.title == $tc('message.patients', 1)" width="30">
            <img src="/img/icons/icone_navbar/gestion_admin.png" class="img-fluid mr-3" alt="Gestion Administrative" v-if="this.$route.meta.title == $t('message.adminManagement') || this.$route.meta.title == $tc('message.institutions', 2) || this.$route.meta.title == $t('message.comptable') || this.$route.meta.title == $t('message.addInstitution')" width="30">
            <img src="/img/icons/icone_navbar/gestion_affil.png" class="img-fluid mr-3" alt="Gestion des paiements" v-if="this.$route.meta.title == $t('message.paymentManagement') || this.$route.meta.title == $t('message.payment') || this.$route.meta.title == $t('message.followUpSouscripteur') || this.$route.meta.title == 'Paiement affiliations' || this.$route.meta.title == $tc('message.paymentPrestation', 1) || this.$route.meta.title == 'Nouvelle affiliation' || this.$route.meta.title == $t('message.donneesAffiliation') || this.$route.meta.title == $t('message.editAffiliation')" width="30">
            <img src="/img/icons/icone_navbar/gestion_act.png" class="img-fluid mr-3" alt="Gestion des activités" v-if="this.$route.meta.title == $t('message.activiteManagement') || this.$route.meta.title == $tc('message.practitioners', 2) || this.$route.meta.title == $t('message.ama') || this.$route.meta.title == $t('message.medecinreferent') || this.$route.meta.title == $t('message.addPractitioners') || this.$route.meta.title == $t('message.add') || this.$route.meta.title == $t('message.ajouterActivite') || this.$route.meta.title == $tc('message.activite.titre', 2)" width="30">
            <img src="/img/icons/icone_navbar/dossier_medical.png" class="img-fluid mr-3" alt="Dossier medical" v-if="this.$route.meta.title == $t('message.medicalManagement') || this.$route.meta.title == $t('message.medicalFiles') || this.$route.meta.title == $t('message.addAllergies') ||this.$route.meta.title == $t('message.addConsul') || this.$route.meta.title == $t('message.editGeneratlConsul') || this.$route.meta.title == $t('message.addCurrentTreatment') || this.$route.meta.title == $t('message.addCompteRenduOp') || this.$route.meta.title == $t('message.addPrescrip') || this.$route.meta.title == $t('message.addLabResults') || this.$route.meta.title == $t('message.addImageryRes') || this.$route.meta.title == $t('message.Addligne')" width="30">
            <img src="/img/icons/icone_navbar/tableau_bord.png" class="img-fluid mr-3" alt="Tableau de Bord" v-if="this.$route.meta.title == $t('message.dashboard') || this.$route.meta.title == $t('message.practionerDashboard')" width="30">
            <img src="/img/icons/icone_navbar/Etablissement_prix.png" class="img-fluid mr-3" alt="Etablissement Prix" v-if="this.$route.meta.title == $t('message.EtablissementPrix')" width="30">
            <img src="/img/icons/icone_navbar/gestion_patient.png" class="img-fluid mr-3" alt="Gestion Patients" v-if="this.$route.meta.title == $t('message.gestionPatient') || this.$route.meta.title == $t('message.medecinPatient') || this.$route.meta.title == $t('message.followUp') || this.$route.meta.title == $t('message.addFollowUp') || this.$route.meta.title == $t('message.addHospitalisation') || this.$route.meta.title == $t('message.addManuscritConsul') || this.$route.meta.title == $t('message.listMedecinControl')" width="30"> 
            <img src="/img/icons/icone_navbar/rendez_vous.png" class="img-fluid mr-3" alt="Rendez-vous" v-if="this.$route.meta.title == $t('message.appointments') || this.$route.meta.title == $tc('message.subscribers', 1)" width="30">
            <img src="/img/icons/icone_navbar/avis_medicaux.png" class="img-fluid mr-3" alt="Avis Médicaux" v-if="this.$route.meta.title == $t('message.medicalAdvice') || this.$route.meta.title == $t('message.addMedicalAdvice')" width="30">
            <img src="/img/icons/icone_navbar/facturations.png" class="img-fluid mr-3" alt="Facturations" v-if="this.$route.meta.title == $tc('message.facturations', 2) || this.$route.meta.title == $tc('message.prestation', 2) || this.$route.meta.title == $tc('message.facture', 2) || this.$route.meta.title == $t('message.importPrestation') || this.$route.meta.title == $t('message.payments') || this.$route.meta.title == $t('message.ajouterFacture')" width="30">
            <img src="/img/icons/icone_navbar/validations.png" class="img-fluid mr-3" alt="Validations" v-if="this.$route.meta.title == $t('message.validations') || this.$route.meta.title == $tc('message.generalConsultations', 1) ||  this.$route.meta.title == $tc('message.generalConsultations', 2) || this.$route.meta.title == $t('message.addAntecedent')" width="30">
            <img src="/img/icons/icone_navbar/subscription.png" class="img-fluid mr-3" alt="Soucription" v-if="this.$route.meta.title == $t('message.SouscripteurDashboard') || this.$route.meta.title == $t('message.listOfAffilaites')" width="30">
            <img src="/img/icons/icone_navbar/care.png" class="img-fluid mr-3" alt="Prise en Charge" v-if="this.$route.meta.title == $t('message.takeCare')" width="30">
            <img src="/img/icons/icone_navbar/alerte_active.png" class="img-fluid mr-3" alt="Alertes" v-if="this.$route.meta.title == $t('Alertes')" width="30">
            <img src="/img/icons/icone_navbar/notification - active.png" class="img-fluid mr-3" alt="Notifications" v-if="this.$route.meta.title == $t('Notifications')" width="30">          </div>
        <div class="">
          <slot name="brand">
            <router-link :to="$route.path" class="h4 mb-0 text-uppercase">
              {{$route.meta.title}}
            </router-link>
          </slot> 
          <b-breadcrumb :items="breadcrumbItems" class="breadscrum"></b-breadcrumb>
        </div>
        <div>
          
        </div>
      </div>
      <navbar-toggle-button v-if="showToggleButton" :toggled="toggled" :target="contentId"
        @click.native.stop="toggled = !toggled">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>

      <div class="m-auto m-md-0 pr-10" :class="{show: toggled}" :id="contentId" v-click-outside="closeMenu">

        <slot :close-menu="closeMenu"></slot>
      </div>
    </div>
    <div>
     <div class="m-2">
      <b-breadcrumb :items="breadcrumbItems" class="breadscrum_1 text-center"></b-breadcrumb>
    </div>
    </div>
  </nav>
</template>
<script>
  import NavbarToggleButton from "./NavbarToggleButton";
  import { mapGetters } from 'vuex';
  export default {
    name: "base-nav",
    components: {
      NavbarToggleButton
    },
    
    props: {
      type: {
        type: String,
        default: "",
        description: "Navbar type (e.g default, primary etc)"
      },
      title: {
        type: String,
        default: "",
        description: "Title of navbar"
      },
      contentId: {
        type: [String, Number],
        default: Math.random().toString(),
        description:
          "Explicit id for the menu. By default it's a generated random number"
      },
      containerClasses: {
        type: [String, Object, Array],
        default: 'container-fluid'
      },
      transparent: {
        type: Boolean,
        default: false,
        description: "Whether navbar is transparent"
      },
      expand: {
        type: Boolean,
        default: false,
        description: "Whether navbar should contain `navbar-expand-lg` class"
      },
      showToggleButton: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        toggled: false,
        ShowSearch: false,
        
      };
    },
    computed :{
       ...mapGetters(["errors","patient","institutions",'hasPatientRole','hasSouscripteurRole','requiredConfirmationRoutesList','breadcrumbItems']),
    },
    methods: {
      closeMenu() {
        this.toggled = false;
      },
      igetWidth: function (){
            if(window.innerWidth <= 420){
                return true;
            }
            return false;
        },
    },
    computed: {
    ...mapGetters(["errors","patient","institutions",'hasPatientRole','hasSouscripteurRole','rMp1oViPb3EdvcJ5kxoqe52RuaiK6YiUYo','breadcrumbItems']),
    },
  };
</script>
<style>
</style>
